import { render, staticRenderFns } from "./StagingCriterionSectionEditor.vue?vue&type=template&id=3d0b6024"
import script from "./StagingCriterionSectionEditor.vue?vue&type=script&lang=ts"
export * from "./StagingCriterionSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingCriterionSectionEditor.vue?vue&type=style&index=0&id=3d0b6024&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports